var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.25C2.58579 4.25 2.25 4.58579 2.25 5V15C2.25 15.4142 2.58579 15.75 3 15.75H17C17.4142 15.75 17.75 15.4142 17.75 15V5C17.75 4.58579 17.4142 4.25 17 4.25H3ZM3.75 6.46589V14.25H16.25V6.46591L11.802 9.88712L11.8019 9.88716C11.2853 10.2846 10.6518 10.5 10 10.5C9.3482 10.5 8.71468 10.2846 8.19805 9.88712L3.75 6.46589ZM14.7204 5.75H5.27959L9.1126 8.69818L9.11265 8.69821C9.36706 8.89393 9.67903 9.00004 10 9.00004C10.321 9.00004 10.633 8.89393 10.8874 8.69821L10.8874 8.69818L14.7204 5.75Z",
    fill: "#676879"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8da7af37.svg";
export { ForwardRef as ReactComponent };